import React, { useContext } from 'react';

import { AppServices } from 'rdx/middleware';

// we do not have default value
export const AppServicesContext = React.createContext<AppServices>({} as any);

export const useAppServices = () => useContext(AppServicesContext);

interface AppServicesProps {
  appServices?: AppServices;
}

export const withAppServices = <P extends Record<string, any>>(
  // eslint-disable-next-line @typescript-eslint/naming-convention
  WrappedComponent: React.ComponentType<P>,
): React.FC<P & AppServicesProps> => {
  return (props: Record<string, any>) => {
    return (
      <AppServicesContext.Consumer>
        {(value) => <WrappedComponent appServices={value} {...(props as P)} />}
      </AppServicesContext.Consumer>
    );
  };
};
